import * as React from 'react';
import * as styles from './QuickLinksBanner.css';
// tslint:disable-next-line: match-default-export-name
import cn from 'classnames';

interface IQuickLinksBannerProps {
  hasLeftBorder?: boolean;
  hasRightBorder?: boolean;
}

export const QuickLinksBanner: React.FC<IQuickLinksBannerProps> = ({ children, hasLeftBorder, hasRightBorder }) => {
  return (
    <div
      className={cn(styles['banner'], {
        [styles['left-border']]: hasLeftBorder,
        [styles['right-border']]: hasRightBorder,
      })}
    >
      {children}
    </div>
  );
};

QuickLinksBanner.displayName = 'QuickLinksBanner';
